__turbopack_context__.v({
  "blockHeader": "LocationInterlinking-module__vELekq__blockHeader",
  "hideSectionForTblt": "LocationInterlinking-module__vELekq__hideSectionForTblt",
  "interlinking": "LocationInterlinking-module__vELekq__interlinking",
  "links": "LocationInterlinking-module__vELekq__links",
  "list": "LocationInterlinking-module__vELekq__list",
  "locationLayout": "LocationInterlinking-module__vELekq__locationLayout",
  "mobileView": "LocationInterlinking-module__vELekq__mobileView",
  "title": "LocationInterlinking-module__vELekq__title",
  "viewMore": "LocationInterlinking-module__vELekq__viewMore",
});
